import { createFileRoute, redirect } from '@tanstack/react-router';

import { requireAuthenticatedRoute } from '@/lib/router-guards';

export const Route = createFileRoute('/onboarding/activate')({
    beforeLoad: async () => {
        await requireAuthenticatedRoute();
        throw redirect({ to: '/onboarding/connect', search: {} as never });
    }
});
